import type { TimelineEvent } from "@productlane/api/src/browser"
import { cn } from "@productlane/lib/src/cn"

// On a cold open the list already synced the thread row, so its note renders
// alone and the messages then arrive around it. Hold both until the first sync.
export function shouldShowTimelineSkeleton(
	events: TimelineEvent[],
	{ syncing, hasSynced }: { syncing: boolean; hasSynced: boolean },
): boolean {
	if (!syncing || hasSynced) return false
	return events.every((event) => event.type === "createdAt")
}

const ROWS = [
	{ name: "w-28", line: "w-3/4" },
	{ name: "w-20", line: "w-1/2" },
	{ name: "w-32", line: "w-2/3" },
]

const BLOCK = "h-3 rounded bg-gray-100 dark:bg-gray-800"

export function TimelineSkeleton() {
	return (
		<div
			aria-busy="true"
			data-testid="timeline-skeleton"
			className="flex flex-col gap-6"
		>
			{ROWS.map((row) => (
				<div key={row.name} className="flex w-full items-start gap-3">
					<div className="h-6 w-6 flex-none rounded-full bg-gray-100 dark:bg-gray-800" />
					<div className="flex min-w-0 flex-1 flex-col gap-2 pt-1">
						<div className={cn(BLOCK, row.name)} />
						<div className={cn(BLOCK, row.line)} />
					</div>
				</div>
			))}
		</div>
	)
}
